import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_burger",
  "use": "icon_burger-usage",
  "viewBox": "0 0 48 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 48 12\" id=\"icon_burger\"><path stroke=\"currentColor\" stroke-linejoin=\"round\" d=\"M0 11h48M0 6h48M0 1h48\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol